/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateManualEnumerationInputDto
 */
export interface UpdateManualEnumerationInputDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateManualEnumerationInputDto
     */
    enumerationOptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateManualEnumerationInputDto
     */
    $type?: UpdateManualEnumerationInputDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateManualEnumerationInputDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateManualEnumerationInputDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateManualEnumerationInputDtoTypeEnum = typeof UpdateManualEnumerationInputDtoTypeEnum[keyof typeof UpdateManualEnumerationInputDtoTypeEnum];



/**
 * Check if a given object implements the UpdateManualEnumerationInputDto interface.
 */
export function instanceOfUpdateManualEnumerationInputDto(value?: unknown): value is UpdateManualEnumerationInputDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateManualEnumerationInputDtoTypeEnum)[0];
}

export function UpdateManualEnumerationInputDtoFromJSON(json: any): UpdateManualEnumerationInputDto {
    return UpdateManualEnumerationInputDtoFromJSONTyped(json, false);
}

export function UpdateManualEnumerationInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateManualEnumerationInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enumerationOptionId': json['enumerationOptionId'] == null ? undefined : json['enumerationOptionId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateManualEnumerationInputDtoToJSON(value?: UpdateManualEnumerationInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'enumerationOptionId': value['enumerationOptionId'],
        '$type': value['$type'],
    });
}

